import trackOrderRoutes from 'sales-flow-ui/domains/track-order/_routes';
import orderSummaryRoutes from 'sales-flow-ui/domains/order-summary/_routes';
import contactRoutes from 'sales-flow-ui/domains/contact/_routes';
import faqRoutes from 'sales-flow-ui/domains/FAQ/_routes';
import cartRoutes from 'sales-flow-ui/domains/cart/_routes';
import checkoutRoutes from 'sales-flow-ui/domains/checkout/_routes';
import thankYouRoutes from 'sales-flow-ui/domains/thank-you/_routes';
import errorRoutes from 'sales-flow-ui/domains/error/_routes';
import VueRouter from 'vue-router';
import { wlRoutes as salesRoutes } from 'sales-flow-ui/domains/sales/_routes';
import { wlRoutes as collectionRoutes } from 'sales-flow-ui/domains/collection/_routes';

import homeRoutes from 'domains/home/_routes';
import staticRoutes from 'domains/static/_routes';

let router = new VueRouter({
  mode: 'history',
  routes: [
    faqRoutes,
    contactRoutes,
    trackOrderRoutes,
    orderSummaryRoutes,
    cartRoutes,
    checkoutRoutes,
    thankYouRoutes,
    collectionRoutes,
    staticRoutes,
    ...homeRoutes,
    errorRoutes[0],
    salesRoutes,
    errorRoutes[1],
  ],
});

export default router;